module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_m_leucistic.f5dd7f75.png";